import { request } from '@koi-design/vix-tools';
import { prefixApi } from './urls';
import type { GetLoginUrlRequest, GetUserInfoRequest, ApiResponse } from './types/wxAuth';

// 获取登录链接
export const getLoginUrlApi = async (params: GetLoginUrlRequest): Promise<string> => {
  return request({
    url: `${prefixApi}/wxAuth/getLoginUrl`,
    method: 'post',
    data: params
  });
};

// 获取员工信息
export const getUserInfoApi = async (params: GetUserInfoRequest): Promise<ApiResponse> => {
  return request({
    url: `${prefixApi}/wxAuth/getUserInfo`,
    catchAll: true,
    method: 'post',
    data: params
  });
};
